import { inject } from 'vue';
import type { Translator } from 'types/injects/translator.type';

const useListingNames = (translator?: Translator): Record<string, string> => {
    const $t = translator ?? (inject('$t') as Translator);

    return {
        clients: $t.__('export.listingNames.clients'),
        prospects: $t.__('export.listingNames.prospects'),
        suppliers: $t.__('export.listingNames.suppliers'),
        contacts: $t.__('export.listingNames.contacts'),
        companies: $t.__('export.listingNames.companies'),
        individuals: $t.__('export.listingNames.individuals'),
        opportunities: $t.__('common.labels.opportunities'),
        pipelines: $t.__('export.listingNames.pipelines'),
        projects: $t.__('export.listingNames.projects'),
        projectentries: $t.__('export.listingNames.projectentries'),
        entrieslist: $t.__('export.listingNames.entrieslist'),
        clientsmap: $t.__('export.listingNames.clientsmap'),
        prospectsmap: $t.__('export.listingNames.prospectsmap'),
        suppliersmap: $t.__('export.listingNames.suppliersmap'),
        companiesmap: $t.__('export.listingNames.companiesmap'),
        individualsmap: $t.__('export.listingNames.individualsmap'),
        recurrings: $t.__('export.listingNames.recurrings'),
        salesbythird: $t.__('export.listingNames.salesbythird'),
        bonus: $t.__('export.listingNames.bonus'),
        'integrity-workflow': $t.__('export.listingNames.integrityWorkflow'),
        salesdocuments: $t.__('export.listingNames.salesdocuments'),
        'sales-invoices': $t.__('common.labels.invoices'),
        saledraftinvoices: $t.__('export.listingNames.saledraftinvoices'),
        'sales-estimates': $t.__('common.labels.estimates'),
        'sales-creditnotes': $t.__('export.listingNames.creditnotes'),
        saledraftcreditnotes: $t.__('export.listingNames.saledraftcreditnotes'),
        'sales-deliveries': $t.__('common.labels.delivery'),
        'sales-proformas': $t.__('export.listingNames.proformas'),
        'sales-orders': $t.__('export.listingNames.orders'),
        'sales-models': $t.__('export.listingNames.models'),
        'sales-documents-rows': $t.__('export.listingNames.salesDocumentsRows'),
        deadlines: $t.__('export.listingNames.deadlines'),
        salethirdspaceestimates: $t.__('export.listingNames.salethirdspaceestimates'),
        salethirdspaceinvoices: $t.__('export.listingNames.salethirdspaceinvoices'),
        salethirdspacecreditnotes: $t.__('export.listingNames.salethirdspacecreditnotes'),
        salethirdspacedeliveries: $t.__('export.listingNames.salethirdspacedeliveries'),
        salethirdspaceproformas: $t.__('export.listingNames.salethirdspaceproformas'),
        salethirdspaceorders: $t.__('export.listingNames.salethirdspaceorders'),
        invoicesforreconciliation: $t.__('export.listingNames.invoicesforreconciliation'),
        creditnotesforreconciliation: $t.__('export.listingNames.creditnotesforreconciliation'),
        purinvoicesforreconciliation: $t.__('export.listingNames.purinvoicesforreconciliation'),
        purcreditnotesforreconciliation: $t.__(
            'export.listingNames.purcreditnotesforreconciliation',
        ),
        'aged-accounts-receivable': $t.__('export.listingNames.agedAccountsReceivable'),
        'aged-accounts-payable': $t.__('export.listingNames.agedAccountsPayable'),
        occurences: $t.__('export.listingNames.occurences'),
        purchaseinvoices: $t.__('export.listingNames.purchaseinvoices'),
        purchasecreditnotes: $t.__('export.listingNames.purchasecreditnotes'),
        purchaseorders: $t.__('export.listingNames.purchaseorders'),
        purchasedeliveries: $t.__('export.listingNames.purchasedeliveries'),
        purchaserows: $t.__('export.listingNames.purchaserows'),
        purchaseitemsordered: $t.__('export.listingNames.purchaseitemsordered'),
        'lightened-opportunities': $t.__('common.labels.opportunities'),
        'lightened-saleinvoices': $t.__('common.labels.invoices'),
        'lightened-saleinvoices-draft': $t.__('export.listingNames.saledraftinvoices'),
        'lightened-saleestimates': $t.__('common.labels.estimates'),
        'lightened-saledeliveries': $t.__('common.labels.delivery'),
        'lightened-saleorders': $t.__('export.listingNames.orders'),
        'lightened-salecreditnotes': $t.__('export.listingNames.creditnotes'),
        'lightened-salecreditnotes-draft': $t.__('export.listingNames.saledraftcreditnotes'),
        'lightened-saleproformas': $t.__('export.listingNames.proformas'),
        'third-annotations': $t.__('export.listingNames.thirdAnnotations'),
        'people-annotations': $t.__('export.listingNames.peopleAnnotations'),
        'opportunity-annotations': $t.__('export.listingNames.opportunityAnnotations'),
        companysearch: $t.__('export.listingNames.companysearch'),
        'catalogue-products': $t.__('export.listingNames.catalogueProducts'),
        'catalogue-products-with-variations': $t.__(
            'export.listingNames.catalogueProductsWithVariations',
        ),
        'catalogue-services': $t.__('export.listingNames.catalogueServices'),
        'catalogue-promotions': $t.__('export.listingNames.cataloguePromotions'),
        'catalogue-variations': $t.__('export.listingNames.catalogueVariations'),
        'accounting-chart': $t.__('export.listingNames.accountingChart'),
        'accounting-accounts': $t.__('export.listingNames.accountingAccounts'),
        'accounting-journal': $t.__('export.listingNames.accountingJournal'),
        'accounting-journal-fec': $t.__('export.listingNames.accountingJournalFec'),
        'crm-activities': $t.__('common.labels.activity'),
        'export': $t.__('export.listingNames.export'),
        'deals-activities': $t.__('common.labels.activities'),
    };
};

export default useListingNames;
